import { useRef } from "react";
import { motion, useScroll, useSpring } from "framer-motion";
import { Section } from "./Section";
import { Reveal } from "./Reveal";
import { TIMELINE } from "../../config/site";

export const Timeline = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 0.7", "end 0.6"] });
  const progress = useSpring(scrollYProgress, { stiffness: 90, damping: 22 });

  return (
    <Section
      id="timeline"
      className="bg-sand/50"
      overline="Construction timeline"
      title="From approval to a working estate"
      sub="Payments are completion-linked — this timeline is what your money follows."
    >
      <div ref={ref} className="relative mx-auto max-w-3xl" data-testid="construction-timeline">
        {/* track */}
        <div className="absolute left-4 sm:left-1/2 top-0 h-full w-px bg-border sm:-translate-x-1/2" />
        <motion.div
          className="absolute left-4 sm:left-1/2 top-0 w-px origin-top bg-gold sm:-translate-x-1/2"
          style={{ scaleY: progress, height: "100%" }}
          data-testid="timeline-progress"
        />

        <div className="space-y-14">
          {TIMELINE.map((t, i) => (
            <Reveal key={t.date} delay={0.05}>
              <div
                className={`relative flex flex-col gap-2 pl-12 sm:w-1/2 sm:pl-0 ${
                  i % 2 === 0
                    ? "sm:pr-12 sm:text-right"
                    : "sm:ml-auto sm:pl-12"
                }`}
                data-testid={`timeline-item-${i}`}
              >
                <div
                  className={`absolute top-1 left-4 h-3.5 w-3.5 -translate-x-1/2 rounded-full border-2 border-gold bg-paper sm:left-auto ${
                    i % 2 === 0 ? "sm:-right-[7px] sm:translate-x-0" : "sm:-left-[7px] sm:-translate-x-0"
                  }`}
                />
                <p className="text-xs uppercase tracking-[0.22em] font-medium text-gold-dark">{t.date}</p>
                <h3 className="font-display text-2xl font-medium text-forest">{t.title}</h3>
                <p className="text-sm leading-relaxed text-[#4A4C4A]">{t.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </Section>
  );
};
